/** @jsxImportSource @emotion/react */
import { Button } from "antd";
import tw, { styled } from "twin.macro";

export const WeddingDetailsWrapper = styled.div`
	${tw`relative`}
	.my-masonry-grid {
		display: flex;
		flex-direction: row;
		gap: 10px;

		.my-masonry-grid_column {
			width: 50%;
			padding: 0 !important;
			margin: 0 !important;
		}
	}
`;

export const ButtonTab = styled(Button)`
	${({ active }) =>
		active
			? tw`shadow min-w-min text-white border-none bg-appPink inline-flex gap-2 items-center justify-center py-4 text-base hover:(bg-appPinkSaturated text-white) active:(bg-appPink text-white border-none) focus:(bg-appPink text-white border-none)`
			: tw`text-appTextFaded! shadow min-w-min border-none text-white bg-appGentleGray inline-flex gap-2 text-base items-center justify-center py-4 hover:(bg-appPinkSaturated text-white) active:(bg-appPink text-white border-none) focus:(bg-appPink text-white border-none)`}
	font-family: Poppins;
	line-height: 12px;
	font-size: 0.75rem;
	letter-spacing: 0.5px;
	height: 40px;
	width: 120px;
	border-radius: 40px;
`;

export const DetailsHomeWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	justify-content: center;
`;

export const CoupleName = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	align-items: center;
	justify-content: center;
	margin-top: 10px;
`;

export const EventContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	align-items: center;
	justify-content: center;
`;

export const ReceptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	align-items: center;
	justify-content: center;
`;

export const ContentWrapper = styled.div`
	height: 50vh;
	overflow-y: auto;
`;
